import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { calculatePercent, roundDec } from '../utils';
import {
  wrapper,
  tagPercent,
  leyend,
  bar,
  percentZone,
  red,
} from './index.module.scss';
import PropTypes from '../../../utils/propTypes';

const DoubleBar = ({ table, values }) => {
  const intl = useIntl();
  const [value1, setValue1] = useState(0);
  const [value2, setValue2] = useState(0);
  const [valueTotal, setValueTotal] = useState(0);

  useEffect(() => {
    const val1 = calculatePercent(values.resistant, values.projected);
    const val2 = calculatePercent(values.poured, values.projected);
    setValue1(val1);
    setValue2(val2);
    setValueTotal(roundDec(val1 + val2));
  }, [values.resistant, values.projected, values.poured]);

  const customTotalProgressBar = {
    outline: '1px solid #D3D3D3',
    display: 'flex',
  };
  return (
    <div className="card-wrapper-table">
      {table}
      <div className={wrapper}>
        <div className={leyend}>
          <span>
            {`${intl.formatMessage({ id: 'concrete.resistant' })}: ${
              values.resistant
            } m`}
            <sup>3</sup>
          </span>
          <span>
            {`${intl.formatMessage({ id: 'concrete.poured' })}: ${
              values.poured + values.resistant
            } m`}
            <sup>3</sup>
          </span>
        </div>
        <div className={bar}>
          <div className={percentZone}>
            <div
              className={tagPercent}
              style={{
                left: `${valueTotal > 100 ? 100 : valueTotal}%`,
              }}
            >
              <span className="percent-text"> {`${valueTotal}%`}</span>
            </div>
          </div>
          <div className="total-progress" style={customTotalProgressBar}>
            <div
              style={{
                width: `${value1 > 100 ? 100 : value1}%`,
                backgroundColor: '#ff0000',
                animationDuration: `${(value1 > 100 ? 100 : value1) / 50}s`,
              }}
            ></div>
            <div
              style={{
                width: `${value2 > 100 ? 100 : value2}%`,
                backgroundColor: 'gray',
                animationDelay: `${(value1 > 100 ? 100 : value1) / 50 + 0.3}s`,
                animationDuration: `${(value2 > 100 ? 100 : value2) / 50}s`,
              }}
            ></div>
            <div
              style={{
                width: `${100 - (valueTotal > 100 ? 100 : valueTotal)}%`,
                backgroundColor: 'gray-white',
              }}
            >
              <span className="metter-ratio"></span>
            </div>
          </div>
          <div className={percentZone}>
            <div
              className={`${tagPercent} ${red}`}
              style={{
                left: `${value1 > 100 ? 100 : value1}%`,
              }}
            >
              <span style={{ color: '#ff0000' }} className="percent-text">
                {' '}
                {`${value1}%`}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DoubleBar.propTypes = {
  table: PropTypes.element.isRequired,
  values: PropTypes.object.isRequired,
};

export default DoubleBar;
